import { render, staticRenderFns } from "./OwalBanner.vue?vue&type=template&id=e72fa3e8&scoped=true"
import script from "./OwalBanner.vue?vue&type=script&lang=js"
export * from "./OwalBanner.vue?vue&type=script&lang=js"
import style0 from "./OwalBanner.vue?vue&type=style&index=0&id=e72fa3e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e72fa3e8",
  null
  
)

export default component.exports